import { defineMessages } from 'react-intl';

export const ErrorBoundary = defineMessages({
  header: {
    id: 'app.components.ErrorBoundary.header',
  },
  body: {
    id: 'app.components.ErrorBoundary.body',
  },
  refresh: {
    id: 'app.components.ErrorBoundary.refresh',
  },
  report: {
    id: 'app.components.ErrorBoundary.report',
  },
});

export const BugReport = defineMessages({
  title: {
    id: 'app.components.ErrorBoundary.header',
  },
  description: {
    id: 'app.components.ErrorBoundary.BugReport.description',
  },
  placeholder: {
    id: 'app.components.ErrorBoundary.BugReport.placeholder',
  },
  fileLimit: {
    id: 'app.components.establishments.routes.meters.DialogRaiseRequest.fileLimit',
  },
});
